export enum EmailSubscriptionType {
    NEWSLETTER = 'NEWSLETTER',
    SOLAR_JOBS = 'SOLAR_JOBS',
    ELECTRICIAN_JOBS = 'ELECTRICIAN_JOBS',
    HEAT_PUMP_JOBS = 'HEAT_PUMP_JOBS',
}
